import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Flag value service for managing flag values.
 */
class FlagValueService {
    /**
     * Create a new flag value.
     *
     * @param {string} projectKey - Project key
     * @param {string} flagKey - Flag key
     * @param {Object} form - Value payload
     * @returns {Promise<Object>} Created value response
     */
    async create(projectKey, flagKey, form) {
        return await apiClient
            .post(
                API_INTERNAL_BASE + `/${projectKey}/flags/${flagKey}/values`,
                form
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * List values for a flag.
     *
     * @param {string} projectKey - Project key
     * @param {string} flagKey - Flag key
     * @returns {Promise<Object>} Values list response
     */
    async list(projectKey, flagKey) {
        return await apiClient
            .get(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/flags/' +
                    flagKey +
                    '/values'
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Remove a flag value.
     *
     * @param {string} projectKey - Project key
     * @param {string} flagKey - Flag key
     * @param {string} valueUlid - Value ULID
     * @returns {Promise<Object>} Remove response
     */
    async remove(projectKey, flagKey, valueUlid) {
        return await apiClient
            .delete(
                API_INTERNAL_BASE +
                    `/${projectKey}/flags/${flagKey}/values/${valueUlid}`
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Update a flag value.
     *
     * @param {string} projectKey - Project key
     * @param {string} flagKey - Flag key
     * @param {string} valueUlid - Value ULID
     * @param {Object} form - Update payload
     * @returns {Promise<Object>} Update response
     */
    async update(projectKey, flagKey, valueUlid, form) {
        return await apiClient
            .put(
                API_INTERNAL_BASE +
                    `/${projectKey}/flags/${flagKey}/values/${valueUlid}`,
                form
            )
            .then((response) => {
                return response.data
            })
    }

    /**
     * Mark a value as the default for a flag.
     *
     * @param {string} projectKey - Project key
     * @param {string} flagKey - Flag key
     * @param {string} valueUlid - Value ULID
     * @returns {Promise<Object>} Update response
     */
    async updateDefault(projectKey, flagKey, valueUlid) {
        return await apiClient
            .patch(
                API_INTERNAL_BASE +
                    '/' +
                    projectKey +
                    '/flags/' +
                    flagKey +
                    '/values/' +
                    valueUlid +
                    '/default',
                {}
            )
            .then((response) => {
                return response.data
            })
    }
}

export default new FlagValueService()
